<template>
    <section class="content">
        <div class="row">
            <bloquear-modal :id="atendimento_id" :show="showBloquear" @close="showBloquear = false" @atualizar="getDataTable()"></bloquear-modal>
            <criar-modal :id="atendimento_id" :show="showCriar" @close="showCriar = false" @atualizar="getDataTable()"></criar-modal>
            <criar-atendimento-modal :id="atendimento_id" :item="itens" :show="showCriarAtendimento" @close="showCriarAtendimento = false" @atualizar="getDataTable()"></criar-atendimento-modal>
            <bloquear-periodo-modal :show="showBloquearPeriodo" :distribuicao_contrato_id="$route.params.distribuicaoContratoId" @close="showBloquearPeriodo = false" @atualizar="getDataTable()"></bloquear-periodo-modal>
            <editar-atendimento-modal tipo="subgrupo" :item="atendimento" @criarAtendimento="criarAtendimento($event)" :show="showEditarAtendimento" @close="showEditarAtendimento = false" @atualizar="getDataTable()"></editar-atendimento-modal>
            <div class="col-md-12">
                <!-- rederizando componente alert -->
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <div class="pull-right">
                            <button class="btn btn-danger" @click.prevent="bloquearPeriodo()" title="Bloquear por período"><i style="font-size:12px" class="fa fa-fw fa-ban"></i> Bloquear por período</button>
                            <button class="btn btn-success" @click.prevent="criarAtendimento()" title="Criar atendimento"><i style="font-size:12px" class="fa fa-fw fa-plus"></i> Criar atendimento</button>
                        </div>
                        <h3 class="box-title">
                            <b>Atendimentos de Subgrupo</b>
                        </h3>
                    </div>
                    <div class="box-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <label>Filtros:</label>
                            </div>
                            <div class="col-md-9">
                                <div class="form-group">
                                    <input type="text" class="form-control" v-model="filtros.nome_subgrupo" placeholder="Entre com NOME do SUBGRUPO" @keyup.enter="filtrar" />
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <select v-model="filtros.sexo" class="form-control">
                                        <option :value="SEXO.AMBOS">AMBOS</option>
                                        <option :value="SEXO.MASCULINO">MASCULINO</option>
                                        <option :value="SEXO.FEMININO">FEMININO</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="form-group">
                                    <label>Período (De)</label>
                                    <input v-model="filtros.data_inicial" class="form-control" type="date" />
                                </div>
                            </div>

                            <div class="col-md-5">
                                <div class="form-group">
                                    <label>Período (Até)</label>
                                    <input v-model="filtros.data_final" class="form-control" type="date" />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label class>&nbsp;</label>
                                    <button @click="filtrar" class="btn btn-default btn-block"><span class="fa fa-filter"></span> Filtrar</button>
                                </div>
                            </div>
                        </div>
                        <table class="table table-bordered table-hover table-striped">
                            <thead>
                                <tr role="row">
                                    <th style="width: 4%">Controle</th>
                                    <th style="width: 11%">Subgrupo</th>
                                    <th style="width: 8%">Sexo</th>
                                    <th style="width: 7%">Idade</th>
                                    <th style="width: 7%">Data</th>
                                    <th style="width: 7%">Horário</th>
                                    <th style="width: 7%;">Atendimentos</th>
                                    <th style="width: 7%">Locais</th>
                                    <th style="width: 7%">Pacientes</th>
                                    <th style="width: 8%">Ação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="even" role="row" v-for="item in dataTable.data" :key="item.id">
                                    <td>{{ item.id }}</td>
                                    <td>{{ item.contrato_subgrupo.subgrupo.nome }}</td>
                                    <td>{{ item.sexo | sexo }}</td>
                                    <td>{{ [item.idade_minima, item.idade_maxima] | intervaloIdade }}</td>
                                    <td>{{ item.data_atendimento | dataFormatada }} <br/> ({{ item.data_atendimento | diaDaSemana }})</td>
                                    <td>{{ [item.hora_inicial, item.hora_final] | intervaloHoras }}</td>
                                    <td style="padding: 2px; margin:0; text-align: center;">
                                        <strong v-if="item.tipo_consumo == 1" style="text-align: center">---</strong>
                                        <table v-else class="table table-bordered table-hover table-striped">
                                            <thead>
                                                <tr role="row">
                                                    <th>M</th>
                                                    <th>D</th>
                                                    <th>B</th>
                                                    <th>C</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="even" role="row">
                                                    <td title="Atendimentos Distribuídos (Modelo)" style="background-color: blue; color: white">{{ item.quantidade_atendimento_original }}</td>
                                                    <td title="Atendimentos Disponíveis" style="background-color: green; color: white">{{ item.quantidade_atendimento }}</td>
                                                    <td title="Atendimentos Bloqueados" style="background-color: #c40233; color: white">{{ item.quantidade_atendimento_bloqueada }}</td>
                                                    <td title="Atendimentos Consumidos" style="background-color: #ffdb58; color: black">{{ item.quantidade_atendimento_consumida }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                    <td style="padding: 2px; margin:0; text-align: center">
                                        <strong v-if="item.tipo_consumo == 1" style="text-align: center">---</strong>
                                        <table v-else class="table table-bordered table-hover table-striped">
                                            <thead>
                                                <tr role="row">
                                                    <th>M</th>
                                                    <th>D</th>
                                                    <th>B</th>
                                                    <th>C</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="even" role="row">
                                                    <td title="Locais Distribuídos (Modelo)" style="background-color: blue; color: white">{{ item.quantidade_local_original }}</td>
                                                    <td title="Locais Disponíveis" style="background-color: green; color: white">{{ item.quantidade_local }}</td>
                                                    <td title="Locais Bloqueados" style="background-color: #c40233; color: white">{{ item.quantidade_local_bloqueada }}</td>
                                                    <td title="Locais Consumidos" style="background-color: #ffdb58; color: black">{{ item.quantidade_local_consumida }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                    <td style="padding: 2px; margin:0; text-align: center">
                                        <strong v-if="item.tipo_consumo != 1" style="text-align: center">---</strong>
                                        <table v-else class="table table-bordered table-hover table-striped">
                                            <thead>
                                                <tr role="row">
                                                    <th>M</th>
                                                    <th>D</th>
                                                    <th>B</th>
                                                    <th>C</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="even" role="row">
                                                    <td title="Atendimentos por Paciente Distribuídos (Modelo)" style="background-color: blue; color: white">{{ item.quantidade_paciente_original }}</td>
                                                    <td title="Atendimentos por Paciente Disponíveis" style="background-color: green; color: white">{{ item.quantidade_paciente }}</td>
                                                    <td title="Atendimentos por Paciente Bloqueados" style="background-color: #c40233; color: white">{{ item.quantidade_paciente_bloqueada }}</td>
                                                    <td title="Atendimentos por Paciente Consumidos" style="background-color: #ffdb58; color: black">{{ item.quantidade_paciente_consumida }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                    <td>
                                        <button class="btn btn-danger btn-sm" @click.prevent="bloquear(item.id)" title="Bloquear Atendimentos">
                                            <i style="font-size:12px" class="fa fa-fw fa-ban"></i>
                                        </button>
                                        <button class="btn btn-success btn-sm" @click.prevent="criar(item.id)" title="Criar Atendimentos">
                                            <i style="font-size:12px" class="fa fa-fw fa-plus"></i>
                                        </button>
                                        <button @click="editar(item)" class="btn btn-info btn-sm" title="Editar Atendimento">
                                            <i style="font-size:12px" class="fa fa-fw fa-edit"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row">
                            <div class="col-sm-5">Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>
                            <div class="col-sm-7" style="text-align:right">
                                <laravue-pagination :limit="5" :data="dataTable" v-on:pagination-change-page="getDataTable">
                                    <span slot="prev-nav">&lt; Anterior</span>
                                    <span slot="next-nav">Próximo &gt;</span>
                                </laravue-pagination>
                            </div>
                        </div>
                        <br />
                        <div class="row">
                            <div class="col-md-12">
                                <button class="btn btn-default pull-left" @click="$router.go(-1)"><i class="fa fa-reply"></i> Voltar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import { SEXO } from "@/constants";
import bloquearModal from "./bloquearSubgruposModal";
import criarModal from "./criarSubgruposModal";
import criarAtendimentoModal from "./criarAtendimentoSubgruposModal";
import bloquearPeriodoModal from "./bloquearSubgruposPeriodoModal";
import editarAtendimentoModal from "./editarAtendimentoModal";

export default {
    filters: {},
    computed: {
        SEXO: function() {
            return SEXO;
        }
    },
    data: () => ({
        showBloquear: false,
        showCriar: false,
        showCriarAtendimento: false,
        showBloquearPeriodo: false,
        showEditarAtendimento: false,
        atendimento_id: null,
        atendimento: {},
		itens: {},
        filtros: {
            nome_subgrupo: "",
            sexo: SEXO.AMBOS,
            tipo: 1,
            coluna: null,
            ordem: null,
            data_inicial: null,
            data_final: null
        },
        dataTable: {}
    }),
    mounted() {
        this.getDataTable();
    },
    methods: {
        filtrar: function(filtros) {
            this.filtros = { ...this.filtros, ...filtros };
            this.getDataTable();
        },
        bloquear(id) {
            this.showBloquear = true;
            this.atendimento_id = id;
        },
        criar(id) {
            this.showCriar = true;
            this.atendimento_id = id;
        },
        editar(atendimento) {
            this.showEditarAtendimento = true;
			let obj = {...atendimento};
			this.atendimento = obj;
        },
        bloquearPeriodo() {
            this.showBloquearPeriodo = true;
        },
		criarAtendimento(dados = '') {

			this.itens = dados;
			this.showCriarAtendimento = true;
		},
        getDataTable(page) {
            if (typeof page === "undefined") {
                page = 1;
            }
            this.filtros.page = page;
            this.filtros.distribuicao_contrato_id = this.$route.params.distribuicaoContratoId;
            this.$store.commit("TOGGLE_LOADING");
            let config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            axios
                .get(`${this.$store.state.serverURI}/api/distribuicao/agenda/getSubgrupoAtendimentosAllPaginate`, config)
                .then(response => {
                    this.dataTable = response.data;
                    this.$store.commit("TOGGLE_LOADING");
                })
                .catch(error => {
                    this.$store.commit("throwException", error);
                });
        }
    },
    // watch: {
    //     page: function(val) {
    //         this.getDataTable();
    //     }
    // },
    components: {
        bloquearModal,
        criarModal,
        criarAtendimentoModal,
        bloquearPeriodoModal,
        editarAtendimentoModal
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// agendasSubgrupos.vue?ac0a6e98